/* eslint-disable no-unused-expressions */
import {Power1} from 'gsap';

import vars from './../../helpers';
import scroller from '../scroller';

const nav = document.querySelector('.navigation');
const isMobile = vars.isMobile();

let isVisible = false;

const showNavigation = () => {
	if (isVisible) {
		return;
	}

	isVisible = true;

	gsap.to(nav, {
		duration: 0.35,
		ease: Power1.linear,
		clearProps: 'all',
		xPercent: 0,
		opacity: 1,
	});
};

const progressscroll = () => {
	const $home = document.querySelector('.home');
	const $progressStatus = document.querySelector('.navigation__progress--status');
	const $scroller = scroller.getElement();

	$scroller.addEventListener('scroll', () => {
		const mainsection = $home.scrollHeight / 2;
		const windowHeight = $scroller.scrollHeight - innerHeight - mainsection;
		const offset = scroller.getPosition() - mainsection;
		const progress = Math.floor(offset / windowHeight * 100);

		let height = progress > 0 ? progress : 0;

		$progressStatus.style.height = `${height}%`;
	});
};

const changeTextNavigation = (node) => {
	const text = node.querySelector('.chapter').dataset.chapterTitle;
	const container = document.querySelector('.navigation__title');
	const h3 = container.querySelector('.navigation__title h3');

	if (text !== h3.currentText) {
		h3.currentText = text;

		gsap.killTweensOf(container);

		gsap.timeline()
			.to(container, {
				onComplete() {
					h3.textContent = text;
				},
				duration: 0.35,
				ease: Power1.easeInOut,
				alpha: 0,
			})
			.to(container, {
				duration: 0.35,
				ease: Power1.easeInOut,
				autoAlpha: 1,
			});
	}
};

const navigation = () => {
	if (!isMobile) {
		gsap.set(nav, {
			opacity: 0,
			xPercent: -100,
		});
	}

	vars.$document.find('.navigation__arrow').on('click', () => {
		const $chapterNext = vars.$document.find('.chapters.is-active').next();

		if ($chapterNext.length) {
			vars.scrollTo($chapterNext, 1000);
		} else {
			vars.scrollTo(vars.$document.find('.chapters:first'), 1000);
		}
	});

	if (!isMobile) {
		progressscroll();
	}
};

export {navigation, showNavigation, changeTextNavigation};
